import { render, staticRenderFns } from "./DefaultNav.vue?vue&type=template&id=29b7a5ba&scoped=true&lang=pug"
import script from "./DefaultNav.vue?vue&type=script&lang=js"
export * from "./DefaultNav.vue?vue&type=script&lang=js"
import style0 from "./DefaultNav.vue?vue&type=style&index=0&id=29b7a5ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b7a5ba",
  null
  
)

export default component.exports